const Linkedin = () => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="social-icon hoverable"
      aria-label="Shakeel Haider's LinkedIn Profile"
    >
      <g clipPath="url(#clip0_141_143)">
        <rect y="11" width="200" height="200" rx="50" fill="white" />
        <path
          d="M170.417 170.417H140.783V124C140.783 112.934 140.583 98.6836 125.367 98.6836C109.933 98.6836 107.567 110.75 107.567 123.184V170.417H77.9333V74.9669H106.383V88.0169H106.783C112.583 78.1169 123.383 72.1836 134.85 72.6002C164.883 72.6002 170.433 92.3502 170.433 118.067L170.417 170.4V170.417ZM44.5 61.9169C39.9479 61.895 35.5882 60.0782 32.3678 56.8609C29.1474 53.6436 27.3263 49.2857 27.3 44.7336C27.3 35.3002 35.0667 27.5336 44.5 27.5336C53.9333 27.5336 61.6833 35.3002 61.7 44.7336C61.7 54.1669 53.9333 61.9169 44.5 61.9169ZM59.3167 170.417H29.65V74.9669H59.3167V170.417ZM185.167 0.000247721H14.75C10.8858 -0.0221961 7.16896 1.48124 4.40705 4.18385C1.64515 6.88646 0.0614111 10.5698 0 14.4336V185.567C0.0614111 189.431 1.64515 193.114 4.40705 195.817C7.16896 198.519 10.8858 200.023 14.75 200H185.183C189.056 200.032 192.785 198.533 195.56 195.831C198.334 193.128 199.93 189.439 200 185.567V14.4169C199.93 10.5474 198.333 6.86239 195.558 4.16506C192.782 1.46773 189.053 -0.0233042 185.183 0.0169132L185.167 0.000247721Z"
          fill="#0A66C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_143">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Linkedin;
